module.exports = __webpack_public_path__ + "img/DE01399.a98dbe3f.png";